<div class="new-version-modal text-center p-4">
    <svg class="info-icon" width="64" height="64" viewBox="0 0 64 64" aria-hidden="true">
        <circle cx="32" cy="32" r="32" fill="#E4EDE3" />
        <path d="M32 29v13M32 22v1" stroke="#275B1F" stroke-width="3.5" stroke-linecap="round" />
    </svg>

    <h4 class="fs-24 fw-800 m-0 mt-3 mb-2 modal-heading">
        New version available
    </h4>

    <p class="fs-16 fw-500 m-0 mb-4 modal-subtext">
        A new version of the panel has been released. Please reload the page to get the latest version.
    </p>

    <div class="d-flex gap-2">
        <button type="button" class="btn btn-outline fw-600 w-100" (click)="later()">Later</button>
        <button type="button" class="btn btn-primary fw-600 w-100" (click)="reload()">Reload</button>
    </div>
</div>
